<script lang="ts">
export default {
   name: "RightMonitor",
};
</script>
<script setup lang="ts">
import AMapLoader from '@amap/amap-jsapi-loader';
import { onMounted, onUnmounted, shallowRef } from 'vue';
import { getAlarmList, deleteAlarmList, sendAlarmList,getMediaList } from "@/api/eventApi/index"
import { useFormatDate } from "@/hooks/userHookDate"
import PhotoPop from "@/components/photo-pop/index.vue"
import HistoryVideoPop from "./components/historyVideoPop.vue"
import { store } from '@/store'
import { DeviceTypeName, EBizCode } from "@/types/enum";
import { EModeCode, EDockModeCode, EGear } from '@/types/device'
import homeAlert from "@/views/homePage/components/home-alert.vue";
import JSWebrtc from "@/vendors/jswebrtc.min.js"
import GPS from '@/utils/gps-convert'
import { CameraMode } from '@/types/live-stream'
import { postDrcEnter, postDrcExit, getShoutList, speakerAudioPlayStart, speakerPlayStop, addSpeaker, modifySpeaker, speakerInfo, drcLightModeSet } from "@/api/monitorApi/drc"
import { usePayloadControl } from './use-payload-control'
import { changeLivestreamLens } from "@/api/monitorApi/drc";
import { ControlSource } from "@/types/enum";
import MapInit from '@/utils/mapinit'
import { DeviceOsdCamera } from '@/types/device';
import { useRoute } from 'vue-router';

const route = useRoute();
const { resetGimbal, checkPayloadAuth, changeCameraFocalLength, switchCameraAim, switchCameraMode, takeCameraPhoto, startCameraRecording, stopCameraRecording, } = usePayloadControl()

const cameraStatus = ref([
   {
      name: "广角",
      value: "wide"
   }, {
      name: "变焦",
      value: "zoom"
   }, {
      name: "红外",
      value: "ir"
   },
])

const mapContainer = ref(null)
const uavMaoContainer = ref(null)

const useDate = useFormatDate()
const map = ref()
const marker = ref()
const switchActive = ref(false)
const initMap = () => {
   MapInit.init()
      .then((T: any) => {
         const imageURL = import.meta.env.VITE_APP_HTTP + "://t0.tianditu.gov.cn/img_w/wmts?" +
            "SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles" +
            "&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}" +
            "&tk=e0441e3f93fe891cf50309a450079525";//卫星图影像
         const imageURLT = import.meta.env.VITE_APP_HTTP + "://t0.tianditu.gov.cn/cia_w/wmts?" +
            "SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles" +
            "&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}" +
            "&tk=e0441e3f93fe891cf50309a450079525";//卫星图标记
         const lay = new T.TileLayer(imageURL, { minZoom: 6, maxZoom: 18 });//创建图层对象
         const lay2 = new T.TileLayer(imageURLT, { minZoom: 6, maxZoom: 18 });//创建图层对象
         var config = { layers: [lay, lay2] };
         // 创建地图实例
         map.value = new T.Map(mapContainer.value, config);
         // 设置地图中心点和缩放级别
         map.value.centerAndZoom(new T.LngLat(airObj.value.basicOsd.longitude, airObj.value.basicOsd.latitude), 16);
         const marker = new T.Marker(new T.LngLat(airObj.value.basicOsd.longitude, airObj.value.basicOsd.latitude));
         map.value.addOverLay(marker);
      })
      .catch()
}

const uavMap: any = shallowRef(null);
let centerMarker: any = null;
const aMap = ref()
const uavInitMap = () => {
   MapInit.init()
      .then((T: any) => {
         aMap.value = T
         const imageURL = import.meta.env.VITE_APP_HTTP + "://t0.tianditu.gov.cn/img_w/wmts?" +
            "SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles" +
            "&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}" +
            "&tk=e0441e3f93fe891cf50309a450079525";//卫星图影像
         const imageURLT = import.meta.env.VITE_APP_HTTP + "://t0.tianditu.gov.cn/cia_w/wmts?" +
            "SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles" +
            "&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}" +
            "&tk=e0441e3f93fe891cf50309a450079525";//卫星图标记
         const lay = new T.TileLayer(imageURL, { minZoom: 6, maxZoom: 18 });//创建图层对象
         const lay2 = new T.TileLayer(imageURLT, { minZoom: 6, maxZoom: 18 });//创建图层对象
         var config = { layers: [lay, lay2] };
         // 创建地图实例
         let currentPosition
         if (deviceInfo.device?.longitude) {
            currentPosition = [deviceInfo.device?.longitude, deviceInfo.device?.latitude]
         } else {
            currentPosition = [deviceInfo.device?.longitude, deviceInfo.device?.latitude]
         }
         // 创建地图实例
         uavMap.value = new T.Map(uavMaoContainer.value, config);
         // 设置地图中心点和缩放级别
         uavMap.value.centerAndZoom(new T.LngLat(currentPosition[0], currentPosition[1]), 16);
         // 添加控件
         uavMap.value.addControl(new T.Control.Zoom());
         // console.log(uavMap.value.getLngLat())
         // centerMarker = new T.Marker(new T.LngLat(currentPosition[0], currentPosition[1]));
         // uavMap.value.addOverLay(centerMarker);
      })
      .catch()
}
//计时器
let timer: NodeJS.Timer | null = null
const updateMap = () => {
   timer = setInterval(() => {
      updateMapLocation()
   }, 500)
}
const updateMapLocation = () => {
   if (deviceInfo.device?.longitude && deviceInfo.device?.longitude !="--") {
      // const centre = GPS.gcj_encrypt(deviceInfo.device?.latitude, deviceInfo.device?.longitude)
      // uavMap.value?.setCenter([centre.lon, centre.lat])
      // centerMarker.setPosition([centre.lon, centre.lat]); //更新点标记位置
      if (centerMarker) {
         uavMap.value.removeOverLay(centerMarker)
      }
      centerMarker = new aMap.value.Marker(new aMap.value.LngLat(deviceInfo.device?.longitude, deviceInfo.device?.latitude));
      uavMap.value.addOverLay(centerMarker);
      uavMap.value.panTo(new aMap.value.LngLat(deviceInfo.device?.longitude, deviceInfo.device?.latitude));
   }

   // centerMarker.position = map?.getCenter();
}

const page = ref({
   page: 1,
   size: 50,
});

const listTimer = ref<ReturnType<typeof setInterval> | null>(null)

const searchValue = ref({
   position: "",
   eventType: "",
   startTime: "2020-01-01",
   endTime: "",
   gatewaySn: "",
   jobId: ""
});

/** 事件列表：shallowRef 降低大列表深度响应式带来的内存与更新开销 */
const warningList = shallowRef<any[]>([])

/** 取消未完成的列表请求，避免轮询叠请求占内存 */
let alarmListAbort: AbortController | null = null
let alarmListFingerprint = ''

async function AlarmList() {
   alarmListAbort?.abort()
   const ac = new AbortController()
   alarmListAbort = ac
   const params = { ...page.value, ...searchValue.value } as any
   try {
      const result = await getAlarmList(params, { signal: ac.signal })
      if (ac.signal.aborted) return
      const newList = Array.isArray(result?.list) ? result.list : []
      const fp =
         newList.length +
         '|' +
         newList.map((x: any) => `${x.warningId ?? ''}:${x.eventTime ?? ''}:${x.eventType ?? ''}`).join(';')
      if (fp === alarmListFingerprint) return
      alarmListFingerprint = fp
      warningList.value = newList
   } catch (e: any) {
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError' || e?.name === 'AbortError') return
      console.warn('[RightMonitor] AlarmList', e)
   }
}

const photoVisible = ref(false)
const photoIndex = ref(0)
const popActive = ref(-1)
const warningBtn = (list: any, i: number) => {
   if (popActive.value == i) {
      popActive.value = -1
      store.informationListStore.informationStore().setWaringList({})
      photoVisible.value = false
   } else {
      popActive.value = i
      store.informationListStore.informationStore().setWaringList(list)
      photoVisible.value = true
   }
}

const str = '--'
const deviceInfo: any = reactive({
   gateway: {
      capacity_percent: str,
      transmission_signal_quality: str,
   },
   dock: {

   },
   device: {
      gear: -1,
      mode_code: EModeCode.Disconnected,
      height: str,
      home_distance: str,
      horizontal_speed: 0,
      vertical_speed: 0,
      wind_speed: str,
      wind_direction: str,
      elevation: str,
      position_state: {
         gps_number: str,
         is_fixed: 0,
         rtk_number: str
      },
      payload: [{
         gimbal_yaw: 0
      }],
      attitude_head: 0,
      battery: {
         capacity_percent: str,
         landing_power: str,
         remain_flight_time: 0,
         return_home_power: str,
      },
      latitude: str,
      longitude: str,
   }
})

// 无人机状态（避免 JSON 深拷贝：WS 高频推送时会产生大量临时对象与 GC 压力）
const deviceInfo1 = computed(() => store.other.useMyStore().deviceState.deviceInfo ?? {})

watch(() => photoVisible.value, (data) => {
   console.log(data)
   if (!data) {
      store.informationListStore.informationStore().setWaringList({})
      photoVisible.value = false
      popActive.value = -1
   }
})

const theEModeCode = reactive(['待机', '准备中', '已准备', '手动', '自动', '航点', '全景', '运行轨迹', 'ADS_B', '返航', '着陆', '强制着陆', '三叶着陆', '升级中', '已断开'])
const uavObj: any = ref()
const ifmActive = ref(false)
let watchDeviceState: any
const airObj = ref()
const factoryList = ref([
   { value: 10, maxValue: 20, minValue: 10, visible: false },
   { value: 5, maxValue: 200, minValue: 2, visible: false },
])

watch(() => store.informationListStore.informationStore().airNumberValue, async (data, oldVal) => {
   // console.log(data)
   searchValue.value.gatewaySn = data
   if (data) {
      uavObj.value = store.informationListStore.informationStore().uavObj
      // console.log(uavObj.value)
      if (uavObj.value.deviceType == 3) {
         factoryList.value = [
            { value: 10, maxValue: 28, minValue: 2, visible: false },
            { value: 5, maxValue: 112, minValue: 2, visible: false },
         ]
      } else if (uavObj.value.deviceType == 2) {
         factoryList.value = [
            { value: 10, maxValue: 28, minValue: 2, visible: false },
            { value: 5, maxValue: 56, minValue: 2, visible: false },
         ]
      } else {
         factoryList.value = [
            { value: 10, maxValue: 20, minValue: 2, visible: false },
            { value: 5, maxValue: 200, minValue: 2, visible: false },
         ]
      }
      /** 必须先停止旧 watch，不能赋值为 null（否则旧监听仍存活，内存持续上涨） */
      if (watchDeviceState) {
         watchDeviceState()
         watchDeviceState = undefined
      }
      watchDeviceState = watch(() => store.other.useMyStore().deviceState, (data, oldVal) => {
         if (data.currentType === DeviceTypeName.Aircraft && data.deviceInfo[uavObj.value.childSn]) {
            deviceInfo.device = data.deviceInfo[uavObj.value.childSn]
         }
         if (data.currentType === DeviceTypeName.Dock && data.dockInfo[searchValue.value.gatewaySn]) {
            deviceInfo.dock = data.dockInfo[searchValue.value.gatewaySn]
            airObj.value = data.dockInfo[searchValue.value.gatewaySn]
         }
      }, {
         deep: true
      })
      console.log(airObj.value)
   } else {
      if (watchDeviceState) {
         watchDeviceState()
         watchDeviceState = undefined
      }
   }
}, {
   immediate: true,
   deep: true
})

watch(() => airObj.value, (data, oldVal) => {
   // console.log(data,oldVal)
   if (oldVal && data.basicOsd && data.basicOsd.longitude != oldVal.basicOsd.longitude) {
      if (map.value) {
         map.value = null
         marker.value = null
      }
      console.log(map.value, marker.value)
      if (ifmActive.value) {
         uavInitMap()
         updateMap()
      } else {
         initMap()
      }
   } else if (!oldVal) {
      if (map.value) {
         map.value = null
         marker.value = null
      }
      console.log(map.value, marker.value)
      if (ifmActive.value) {
         uavInitMap()
         updateMap()
      } else {
         // switchActive.value = true
         initMap()
      }
   }
}, {
   deep: true
})
const leftActive = ref(true)

watch(() => store.informationListStore.informationStore().contractActive, (data, oldVal) => {
   console.log(data)
   leftActive.value = data
   if (data) {
      initMap()
   } else {
      uavInitMap()
      updateMap()
   }
}, {
   deep: true
})

watch(() => store.informationListStore.informationStore().airValueActive, (data, oldVal) => {
   console.log(data)
   if (data == 1) {
      ifmActive.value = false
      initMap()
      clearInterval(Number(timer));
   } else {
      ifmActive.value = true
      setTimeout(() => {
         uavInitMap()
         updateMap()
      }, 1000)
   }
}, {
   deep: true
})

let playerVideo: any = null
const getPlayableWebrtcUrl = (url: any) => {
   if (typeof url !== "string") return ""
   const trimUrl = url.trim()
   if (!trimUrl) return ""
   if (trimUrl.startsWith("webrtc://")) return trimUrl
   // 部分接口会返回 http(s) 地址，JSWebrtc 仅支持 webrtc 协议
   if (trimUrl.startsWith("http://")) return trimUrl.replace("http://", "webrtc://")
   if (trimUrl.startsWith("https://")) return trimUrl.replace("https://", "webrtc://")
   return ""
}

const initVideo = (url: any) => {
   const playUrl = getPlayableWebrtcUrl(url)
   if(playerVideo){
      playerVideo.destroy()
      playerVideo = null
   }
   if (!playUrl) {
      return
   }
   setTimeout(() => {
      let videoDom: any = document.getElementById("webrtcVideo")		// 初始化播放器 
      if (!videoDom) {
         return
      }
      playerVideo = new JSWebrtc.Player(playUrl, {
         video: videoDom,
         autoplay: true,
         onPlay: (obj: any) => {
            // 监听video元素状态，可播放时进行播放 。 某些情况下  autoplay 会失效
            // mdn https://developer.mozilla.org/zh-CN/docs/Web/API/HTMLMediaElement/canplay_event
            // 菜鸟 https://www.runoob.com/tags/av-event-canplay.html
            videoDom.addEventListener('canplay', function onCanPlayOnce() {
               videoDom.play()
            }, { once: true })
         }
      })
   }, 1000)
}


const deletBtn = (list: any) => {
   deleteAlarmList(list.warningId).then((res) => {
      ElMessage.success("删除成功")
      AlarmList()
   })
}

const pushBtn = (list: any) => {
   sendAlarmList(list).then((res) => {
      ElMessage.success("推送成功")
      AlarmList()
   })
}

const treatActive = ref(false)
const homeEventVisible = ref(false)
const uavSwitch = ref(true)
const treatBtn = () => {
   treatActive.value = false
   switchActive.value = false
   homeEventVisible.value = true
   store.informationListStore.informationStore().setTreatActive(treatActive.value)
   initVideo(store.informationListStore.informationStore().videoUrl)
}

const videoBtn = () => {
   treatActive.value = true
   switchActive.value = true
   // homeEventVisible.value = false
   store.informationListStore.informationStore().setTreatActive(treatActive.value)
   initMap()
}

const airSwitchBtn = () => {
   treatActive.value = !treatActive.value
   switchActive.value = !switchActive.value
   store.informationListStore.informationStore().setTreatActive(treatActive.value)
   if (treatActive.value) {
      initMap()
   } else {
      initVideo(store.informationListStore.informationStore().videoUrl)
   }
}

const switchBtn = () => {
   treatActive.value = !treatActive.value
   uavSwitch.value = !uavSwitch.value
   store.informationListStore.informationStore().setTreatActive(treatActive.value)
   if (treatActive.value) {
      uavInitMap()
   } else {
      initVideo(store.informationListStore.informationStore().videoUrl)
   }
}

const uavVideoBtn = () => {
   treatActive.value = true
   uavSwitch.value = true
   store.informationListStore.informationStore().setTreatActive(treatActive.value)
   uavInitMap()
}

watch(() => store.informationListStore.informationStore().treatActive,
   (newVal: boolean,oldVal: boolean) => {
      console.log(newVal,oldVal)
      if (newVal) {
         treatActive.value = true
         switchActive.value = true
         ifmActive.value = true
         uavInitMap()
         updateMap()
      } else {
         switchActive.value = false
         treatActive.value = false
         ifmActive.value = false
         // homeEventVisible.value = true
         initVideo(store.informationListStore.informationStore().videoUrl)
      }
   }, {
      immediate:true,
   deep: true
}
);

watch(() => store.informationListStore.informationStore().videoUrl, (data, oldVal) => {
   console.log(data)
   if (data) {
      initVideo(store.informationListStore.informationStore().videoUrl)
   }
}, {
   deep: true
})

const changeIdentify = (val: any) => {
   // console.log(val)
   store.informationListStore.informationStore().setIdentifyType(val)
}

const lightValue = ref(0)

const strobeLight = (val: any) => {
   drcLightModeSet({
      psdkIndex: 4,
      index:0,
      value: val,
      deviceSn: store.informationListStore.informationStore().uavObj?.deviceSn
   }).then((res) => {
      if (val) {
         ElMessage.success("爆闪灯开启")
      } else {
         ElMessage.success("爆闪灯关闭")
      }
   })
}

// 负载控制
const payloadSelectInfo = {
   value: null as any,
   controlSource: undefined as undefined | ControlSource,
   options: [] as any,
   payloadIndex: '' as string,
   camera: undefined as undefined | DeviceOsdCamera // 当前负载osd信息
}
const recordingValue = ref(false)
const deviceState = computed(() => store.other.useMyStore().deviceState)
const cameraAction = ref(payloadSelectInfo.camera?.camera_mode)
const cameraRecording = ref(true)
watch(() => deviceInfo.device, (droneOsd) => {
   // console.log(droneOsd)
   if (droneOsd && droneOsd.cameras) {
      payloadSelectInfo.camera = droneOsd.cameras
      cameraAction.value = payloadSelectInfo.camera?.camera_mode
      // console.log(cameraAction.value,payloadSelectInfo.camera?.recording_state)
      if (cameraAction.value == 1 && payloadSelectInfo.camera?.recording_state == 1) {
         recordingValue.value = true
      } else {
         recordingValue.value = false
      }
   } else {
      payloadSelectInfo.camera = undefined
   }
   cameraRecording.value = !payloadSelectInfo.camera?.recording_state
   //   if (!cameraRecording.value) {
   //     isRunning.value
   //     increment()
   //   }
}, {
   // immediate: true,
   deep: true
})

const onSwitchCameraMode = async (type: number) => {
   console.log(type)
   console.log(cameraAction.value)
   console.log(recordingValue.value)
   if (cameraAction.value == type) {
      if (cameraAction.value == 0) {
         onTakeCameraPhoto()
      } else {
         if (!recordingValue.value) {
            onStartCameraRecording()
         } else {
            onStopCameraRecording()
         }
      }
   } else {
      if (!checkPayloadAuth(ControlSource.A)) {
         return
      }
      if (type == 0) {
         if (recordingValue.value) {
            ElMessage.warning("请先结束录像再进行拍照")
            return
         }
      }
      const currentCameraMode = payloadSelectInfo.camera?.camera_mode
      const code = await switchCameraMode(store.informationListStore.informationStore().airNumberValue, {
         payload_index: store.informationListStore.informationStore().payloadIndex,
         camera_mode: currentCameraMode === CameraMode.Photo ? CameraMode.Video : CameraMode.Photo
      })
      console.log(code)
      cameraAction.value = type
      if (cameraAction.value == 0) {
         onTakeCameraPhoto()
      } else {
         if (!recordingValue.value) {
            onStartCameraRecording()
         } else {
            onStopCameraRecording()
         }
      }
   }
}

// 拍照
async function onTakeCameraPhoto() {
   if (!checkPayloadAuth(ControlSource.A)) {
      return
   }
   await takeCameraPhoto(store.informationListStore.informationStore().airNumberValue, store.informationListStore.informationStore().payloadIndex)
}


//开始录像
async function onStartCameraRecording() {
   if (!checkPayloadAuth(ControlSource.A)) {
      return
   }
   const code = await startCameraRecording(store.informationListStore.informationStore().airNumberValue, store.informationListStore.informationStore().payloadIndex)
   recordingValue.value = true
}
//结束录像
async function onStopCameraRecording() {
   if (!checkPayloadAuth(ControlSource.A)) {
      return
   }
   const code = await stopCameraRecording(store.informationListStore.informationStore().airNumberValue, store.informationListStore.informationStore().payloadIndex)
   recordingValue.value = false
}

const cameraType = ref("wide")
const isNotFpv = ref(false)
const factoryMode = ref()
// 调整广角、红外、焦距
const changeFactory = (mode: string) => {
   cameraType.value = mode
   changeLivestreamLens({
      videoId: store.informationListStore.informationStore().videoId,
      videoType: mode,
      urlType: 1,
      videoQuality: 0,
   }).then(res => {
      console.log(res)
      let msg = '广角开启成功'
      if (mode === 'ir') {
         factoryList.value[0].visible = true
         factoryList.value[1].visible = false
         msg = '红外开启成功'
      }
      if (mode === 'zoom') {
         factoryList.value[1].visible = true
         factoryList.value[0].visible = false
         msg = '变焦模式开启成功'
      }
      factoryMode.value = mode
      ElMessage.success(msg)
   })
}

const changeSlider = (index: number) => {
   console.log(index)
   return changeCameraFocalLength(store.informationListStore.informationStore().airNumberValue, {
      payload_index: store.informationListStore.informationStore().payloadIndex,
      camera_type: factoryMode.value,
      zoom_factor: factoryList.value[index].value
   })
}

const shoutActive = ref(false)
const shoutList = ref()
const shoutBtn = () => {
   shoutActive.value = true
   getShoutList({
      page: 1,
      size: 999
   }).then((res) => {
      shoutList.value = res.list
   })
}

const shoutValue = ref()
const shoutObject = ref()
const selectShoutBtn = (list: any, i: any) => {
   console.log(list)
   shoutObject.value = list
   shoutValue.value = i
}

const saveBtn = () => {
   let params: any = {}
   params.deviceSn = shoutObject.value.deviceSn
   params.contentId = shoutObject.value.contentId
   params.content = shoutObject.value.content
   addSpeaker(params).then((res) => {
      ElMessage.success("保存成功")
      shoutActive.value = false
   })
}

const cancelBtn = () => {
   shoutActive.value = false
}

const cycleValue = ref(0)
const cycleBtn = () => {
   if (cycleValue.value == 0) {
      cycleValue.value = 1
   } else {
      cycleValue.value = 0
   }
}

const shoutObj = ref()
const shoutgif = ref(false)
const startShout = async () => {
   await speakerInfo(shoutObject.value.deviceSn).then((res) => {
      console.log(res)
      shoutObj.value = res
   })
   await speakerAudioPlayStart({
      playMode: cycleValue.value,
      content: shoutObj.value.content,
      contentId: shoutObj.value.contentId,
      deviceSn: store.informationListStore.informationStore().uavObj?.deviceSn
   }).then((res) => {
      ElMessage.success("喊话成功")
      if (cycleValue.value == 0) {
         shoutgif.value = true
         setTimeout(() => {
            shoutgif.value = false
         }, 2000)
      } else {
         shoutgif.value = true
      }
   })
}

const stopShout = () => {
   speakerPlayStop({
      deviceSn: store.informationListStore.informationStore().uavObj?.deviceSn
   }).then((res) => {
      ElMessage.success("停止喊话")
      shoutgif.value = false
   })
}

const resetValue = ref(-1)
const resetbtn = (i: number) => {
   resetValue.value = i
   return resetGimbal(store.informationListStore.informationStore().airNumberValue, {
      payload_index: store.informationListStore.informationStore().payloadIndex,
      reset_mode: resetValue.value
   })
}

const productId = ref()
const videoObj = ref()
const videoList = () => {
   console.log(store.informationListStore.informationStore().uavObj)
   getMediaList({
      fileType:"VIDEO",
      deviceSn:store.informationListStore.informationStore().uavObj.childSn,
      waylineId:"",
      startTime:"",
      endTime:"",
      subFileType:"1,2,3",
      page:1,
      size:999
   }).then((res:any)=>{
      videoObj.value = res.list[0]
   })
}
function formatTimestamp(timestamp: any) {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return date.toLocaleString(); // 根据本地时间格式显示
}
const isHistory = ref(false)

const historyBtn = () => {
   isHistory.value = true
}

watch(()=>store.informationListStore.informationStore().uavObj,(newVal)=>{
    console.log(newVal)
    initVideo(store.informationListStore.informationStore().videoUrl)
    videoList()
})

onMounted(() => {
   // AlarmList()
   // initVideo(store.informationListStore.informationStore().videoUrl)
   if(sessionStorage.getItem("type")){
      productId.value = sessionStorage.getItem("type")
   }
   if(store.informationListStore.informationStore().treatActive){
      treatActive.value = true
      switchActive.value = true
      ifmActive.value = true
      uavInitMap()
      updateMap()
   }
   listTimer.value = setInterval(() => {
      void AlarmList()
   }, 10000)
   void AlarmList()
})


onUnmounted(() => {
   console.log(123)
   store.informationListStore.informationStore().setTreatActive(false)
   switchActive.value = false
   // console.log(document.getElementById("webrtcVideo"))
   store.informationListStore.informationStore().setVideoUrl("")
   alarmListAbort?.abort()
   alarmListAbort = null
   if (timer != null) {
      clearInterval(timer as ReturnType<typeof setInterval>)
      timer = null
   }
   if (listTimer.value != null) {
      clearInterval(listTimer.value)
      listTimer.value = null
   }
   if (watchDeviceState) {
      watchDeviceState()
      watchDeviceState = undefined
   }
   if (playerVideo) {
      try {
         playerVideo.destroy()
      } catch {
         /* ignore */
      }
      playerVideo = null
   }
})

</script>

<template>
   <div class="right-monitor" v-if="leftActive">
      <div class="mointor-block">
         <div class="event-box" v-if="!ifmActive" :style="ifmActive ? 'height:40vh;' : 'height: 82vh;'">
            <div class="title-box">
               <p v-if="switchActive">实时位置</p>
               <p v-else>实时监控</p>
            </div>
            <div v-if="switchActive" style="position: relative;">
               <div class="mapContainer" id="mapContainer" ref="mapContainer"></div>
               <!-- <div class="treat" @click="treatBtn">一键出警</div> -->
            </div>
            <div class="videoBox" v-else>
               <video id="webrtcVideo" ref="webrtcVideo" controls="false"
                  style="width: 100%;height: 100%;object-fit: fill"></video>
            </div>
            <!-- <div class="switch-btn" @click="airSwitchBtn">
               <img src="@/assets/images/switch-btn.png" alt="">
            </div> -->

            <div v-if="productId == 1">
               <div class="title-box" style="margin-top: 1.4vh;">
                  <p>无人机照片及视频</p>
               </div>
               <div class="image-video-box">
                  <div class="image-video-list">
                     <div class="left-img">
                        <img :src="videoObj?.previewObjectUrl" alt="">
                     </div>
                     <div class="right-word">
                        <div @click="historyBtn">查看历史视频 >></div>
                        <div>
                           <p>拍摄时间：{{formatTimestamp(videoObj?.createTime)}}</p>
                        <p>拍摄航线：****</p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>


            <div class="title-box" style="margin-top: 1.4vh;">
               <p>事件列表</p>
            </div>
            <div class="event-list-box" :style="productId == 1? 'height: 37vh;':'height: 65vh;'">
               <div class="event-list" v-for="(item, index) in warningList" :key="item.warningId ?? index"
                  :class="{ 'list-box-active': popActive === index }" @click="warningBtn(item, index)">
                  <div class="deletBtn" @click.stop="deletBtn(item)">
                     <img src="@/assets/icons/shanchu.png" alt="">
                  </div>
                  <div class="pushBtn" @click.stop="pushBtn(item)">推送</div>
                  <div class="left-list">
                     <p :title="item.eventTime">
                        时间：{{ item.eventTime }}

                     </p>
                     <p :title="item.name">地点：{{ item.name }}</p>
                     <p style="color: #409EFF;">类型：{{ item.eventType }}</p>
                  </div>
                  <div class="right-list">
                     <img v-if="item.eventImages && item.eventImages.length" :src="item.eventImages[0].image" alt="">
                  </div>
               </div>
            </div>
         </div>
         <div class="event-pic-box" v-if="ifmActive">
            <div class="title-box">
               <p v-if="uavSwitch">实时位置</p>
               <p v-else>实时监控</p>
            </div>
            <div v-if="uavSwitch" id="uavMaoContainer" class="mapContainer" ref="uavMaoContainer"></div>
            <div class="videoBox" v-else>
               <video id="webrtcVideo" ref="webrtcVideo" controls="false"
                  style="width: 100%;height: 100%;object-fit: fill"></video>
            </div>
            <!-- <div class="switch-btn" @click="switchBtn">
               <img src="@/assets/images/switch-btn.png" alt="">
            </div> -->
            <div class="title-box" style="margin-top: 2.1vh;">
               <p>事件图传</p>
            </div>
            <div class="scroll_nav">
               <el-carousel class="swiper_box">
                  <el-carousel-item class="box" v-for="(item, index) in warningList" :key="item.warningId ?? index"
                     @click="warningBtn(item, index)">
                     <img v-if="item.eventImages && item.eventImages.length" :src="item.eventImages[0].image" alt="">
                  </el-carousel-item>
               </el-carousel>
            </div>
         </div>
         <div class="information-box" v-if="ifmActive">
            <div class="title-box" style="margin-top: 2.1vh;">
               <p>挂载控制</p>
            </div>
            <div class="mount-top">
               <div class="mount-left">
                  <div class="switch-box">
                     <el-form>
                        <el-form-item label="识别功能:" label-position="left" class="shibie">
                           <el-switch v-model="store.informationListStore.informationStore().identifyType" inline-prompt
                              active-text="开" inactive-text="关" :active-value="2" :inactive-value="1"
                              style="--el-switch-on-color: rgba(64, 255, 249, 0.83);" @change="changeIdentify" />
                        </el-form-item>
                        <el-form-item label="爆闪灯:" label-position="left" class="yehang">
                           <el-switch inline-prompt active-text="开" inactive-text="关" :active-value="1"
                              :inactive-value="0" style="--el-switch-on-color: rgba(64, 255, 249, 0.83);"
                              v-model="lightValue" @change="strobeLight" />
                        </el-form-item>
                     </el-form>
                  </div>
                  <div class="photo-box">
                     <div @click="onSwitchCameraMode(0)">
                        <img src="@/assets/images/paizhao.png" alt="">
                        <p>拍照</p>
                     </div>
                     <div @click="onSwitchCameraMode(1)">
                        <img src="@/assets/images/luxiang.png" alt=""
                           v-if="cameraAction == 1 && !recordingValue || cameraAction == 0">
                        <img src="@/assets/images/tingzhilx.png" alt="" v-if="cameraAction == 1 && recordingValue">
                        <p v-if="cameraAction == 0">录像</p>
                        <p v-if="cameraAction == 1 && !recordingValue">开始录像</p>
                        <p v-if="cameraAction == 1 && recordingValue">停止录像</p>
                     </div>
                  </div>
               </div>
               <div class="mount-right">
                  <div class="shotCut-box">
                     <p v-for="(item, index) in cameraStatus" :key="index"
                        :class="cameraType == item.value ? 'posActive' : ''" @click="changeFactory(item.value)">
                        {{ item.name }}</p>
                  </div>
                  <div class="sliderBox" v-if="cameraType != 'wide'">
                     <el-slider v-model="factoryList[0].value" vertical height="150px" :max="factoryList[0].maxValue"
                        :min="factoryList[0].minValue" @change="changeSlider(0)" v-if="cameraType == 'ir'" />

                     <el-slider v-model="factoryList[1].value" vertical height="150px" :max="factoryList[1].maxValue"
                        :min="factoryList[1].minValue" @change="changeSlider(1)" v-if="cameraType == 'zoom'" />
                  </div>
               </div>
            </div>
            <div class="mount-bottom">
               <div class="shout-box">
                  <p style="font-family: AlibabaPuHuiTi;font-size: .75rem;color: #0BE8F6;text-decoration-line: underline;text-align: center;margin: 10px 0;cursor: pointer;"
                     @click="shoutBtn">
                     喊话器内容选择</p>
                  <div class="shout-flex">
                     <div class="shout-word" @click="startShout">
                        <p>
                           <img src="@/assets/icons/hanhua.png" alt="">
                        </p>
                        <p style="width: 1.6vw;height: 3.7vh;position: absolute;top: -0.3vh;left: 1.6vw;"
                           v-if="shoutgif">
                           <img src="@/assets/images/shout-gif.gif" alt="" style="width: 30px;height: 40px;">
                        </p>
                        <p>远程喊话</p>
                     </div>
                     <div class="shout-word" @click="stopShout">
                        <p>
                           <img src="@/assets/icons/tzhh.png" alt="">
                        </p>
                        <p>停止喊话</p>
                     </div>
                  </div>
                  <div style="display: flex;align-items: center;margin-left: 3.2vw;height: 1.7vh;margin-top: 1.1vh;"
                     @click="cycleBtn">
                     <p style="color: #fff;font-size: .75rem;line-height: 10px;font-family: AlibabaPuHuiTi;">
                        循环播放</p>
                     <p style="margin-left: .4vw;width: 0.9vw;height: 1.7vh;">
                        <img style="width: 0.9vw;height: 1.7vh;" src="@/assets/icons/weidianji.png" alt=""
                           v-if="!cycleValue">
                        <img style="width: 0.9vw;height: 1.7vh;" src="@/assets/icons/dianji.png" alt="" v-else>
                     </p>
                  </div>
               </div>
               <div class="control-box">
                  <div class="panTilt-box" @click="resetbtn(0)">
                     <p>
                        <img src="@/assets/icons/huizhong.png" alt="">
                     </p>
                     <p>云台回中</p>
                  </div>
                  <div class="panTilt-box" style="margin-top: 2.8vh;" @click="resetbtn(1)">
                     <p>
                        <img src="@/assets/icons/xiangxia.png" alt="">
                     </p>
                     <p>云台朝下</p>
                  </div>
               </div>
            </div>
         </div>
      </div>

      <HistoryVideoPop v-model:isHistory="isHistory"/>
      <photo-pop v-model:photoVisible="photoVisible" :photoIndex="photoIndex" />
   </div>
   <!-- 喊话弹窗 -->
   <div class="shoutDialog" v-if="shoutActive">
      <div style="position: relative;">
         <div class="closeBtn" @click="cancelBtn">
            <img src="@/assets/icons/close-btn.png" alt="">
         </div>
      </div>
      <div
         style="font-family: YouSheBiaoTiHei;font-size: 1.125rem;color: #FFFFFF;text-shadow: 0px 0.8px 1.88px rgba(0, 253, 255, 0.502);margin: 11px 0 0 23px;">
         喊话器内容选择：</div>
      <div class="selectBox">
         <div class="selectlist" v-for="(item, index) in shoutList" @click="selectShoutBtn(item, index)">
            <p>
               <img src="@/assets/icons/weixuanze.png" alt="" v-if="shoutValue != index">
               <img src="@/assets/icons/yixuanze.png" alt="" v-else>
            </p>
            <p>{{ item.content }}</p>
         </div>
      </div>
      <div class="saveBtn">
         <p class="cancel" @click="cancelBtn">取消</p>
         <p class="save" @click="saveBtn">确认</p>
      </div>
   </div>
   <!-- <home-alert v-model:homeEventVisible="homeEventVisible" /> -->
</template>

<style scoped lang="scss">
.right-monitor {
   position: absolute;
   top: 0px;
   right: 0px;
   width: 29.2vw;
   height: 100vh;
   background: url("@/assets/icons/right-bg.png") no-repeat center;
   background-size: 100% 100%;
   // z-index: 1;
   pointer-events: all;
   // pointer-events: none;

   .title-box {
      width: 19.5vw;
      height: 2.5vh;
      background: url("@/assets/icons/title-bg.png") no-repeat center;
      background-size: cover;
      display: flex;

      p:nth-child(1) {
         font-family: YouSheBiaoTiHei;
         font-size: 1.125rem;
         font-weight: normal;
         color: #fff;
         margin: 0 0 0 1.5vw;
         line-height: 2.1vh;
      }
   }

   .mointor-block {
      width: 20.2vw;
      height: 100vh;
      margin-top: 7.6vh;
      position: absolute;
      right: 0px;
      pointer-events: all;
   }

   .event-box {
      height: 82vh;

      .mapContainer {
         width: 19.5vw;
         height: 17.6vh;
         margin-top: 1.6vh;

         :deep(.amap-logo) {
            display: none !important;
         }

         :deep(.amap-copyright) {
            display: none !important;
         }
      }

      .videoBox {
         width: 19.5vw;
         height: 17.6vh;
         margin: 0 auto;
         margin-top: 1.6vh;
      }

      .switch-btn {
         width: 1.5vw;
         height: 2.3vh;
         position: absolute;
         top: 4.8vh;
         right: .7vw;
         cursor: pointer;
         z-index: 999;
      }

      .treat {
         position: absolute;
         bottom: 1.4vh;
         left: 50%;
         transform: translate(-50%, 0);
         width: 9.8vw;
         height: 3vh;
         background: linear-gradient(270deg, rgba(253, 202, 0, 0.8) 0%, rgba(248, 128, 0, 0.6) 100%);
         box-sizing: border-box;
         // border: 0.5px solid ;
         border-image: linear-gradient(270deg, #FFFFFF 0%, #FAA700 97%) 0.5;
         // backdrop-filter: blur(5.44px);
         border-radius: 3px;
         font-size: .875rem;
         font-weight: 600;
         color: #FFFFFF;
         font-family: AlibabaPuHuiTi;
         line-height: 3vh;
         text-align: center;
         cursor: pointer;
      }

      .image-video-box {
         width: 19.4vw;
         margin-top: .6vh;
         overflow-y: auto;
         cursor: pointer;

         .image-video-list {
            width: 19.4vw;
            height: 23vh;
            border-radius: 5px;
            background: rgba(0, 117, 227, 0.35);
            box-sizing: border-box;
            border: 1px solid #00E5FF;
            margin-top: 13px;

            .left-img {
               width: 18.4vw;
               height: 17vh;
               margin: 0px auto;
               margin-top: 10px;
               img {
                  width: 100%;
                  height: 100%;
               }
            }

            .right-word {
               width: 18vw;
               display: flex;
               justify-content: space-between;
               align-items: center;
               margin: 0px auto;
               // margin-left: 36px;
               p {
                  font-size: .75rem;
                  font-weight: normal;
                  color: #FFFFFF;
                  margin: 6px 0;
               }
               div:nth-child(1){
                  color: #0BE8F6;
                  font-size: .75rem;
                  font-weight: normal;
               }
            }
         }
      }

      .event-list-box {
         width: 19.4vw;
         height: 65vh;
         margin-top: .6vh;
         overflow-y: auto;
         cursor: pointer;

         .event-list {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 18.4vw;
            height: 8.3vh;
            background: linear-gradient(270deg, rgba(83, 115, 132, 0.14) 5%, rgba(9, 77, 126, 0.65) 100%);
            box-sizing: border-box;
            border: 1px solid;
            border-image: linear-gradient(270deg, rgba(136, 141, 141, 0.06) 0%, rgba(136, 141, 141, 0.38) 97%) 1;
            margin-top: 1.1vh;
            position: relative;

            .deletBtn {
               width: 0.8vw;
               height: 1.5vh;
               position: absolute;
               right: -0.4vw;
               top: -1vh;

               img {
                  width: 100%;
                  height: 100%;
               }
            }

            .pushBtn {
               width: 2.3vw;
               height: 1.9vh;
               background: #409EFF;
               border-radius: 3px 3px 3px 3px;
               font-size: .75rem;
               font-family: AlibabaPuHuiTi;
               color: #FFFFFF;
               text-align: center;
               line-height: 1.9vh;
               position: absolute;
               right: 0.4vw;
               bottom: .8vh;
            }

            .left-list {
               width: 10.8vw;
               font-size: .875rem;
               font-family: AlibabaPuHuiTi;
               color: #fff;
               display: flex;
               flex-direction: column;
               justify-content: center;
               margin-left: 0.6vw;

               p {
                  margin: .3125rem 0;
                  white-space: nowrap;
                  /* 确保文本在一行内显示 */
                  overflow: hidden;
                  /* 隐藏溢出的内容 */
                  text-overflow: ellipsis;
               }
            }

            .right-list {
               width: 5.4vw;
               height: 6.5vh;
               margin-right: 0.4vw;

               img {
                  width: 100%;
                  height: 100%;
               }
            }
         }

         .list-box-active {
            background-color: rgba(0, 0, 0, 1);
         }
      }
   }

   .event-pic-box {
      .mapContainer {
         width: 19.5vw;
         height: 17.6vh;
         margin-top: 1.6vh;

         :deep(.amap-logo) {
            display: none !important;
         }

         :deep(.amap-copyright) {
            display: none !important;
         }
      }

      .videoBox {
         width: 19.5vw;
         height: 17.6vh;
         margin-top: 1.6vh;
      }

      .switch-btn {
         width: 1.5vw;
         height: 2.3vh;
         position: absolute;
         top: 4.8vh;
         right: .7vw;
         cursor: pointer;
         z-index: 999;
      }

      .scroll_nav {
         width: 19.5vw;
         height: 17.6vh;
         display: flex;
         align-items: center;
         justify-content: center;
         margin-top: 1.9vh;

         .swiper_box {
            width: 100%;
            height: 100%;
            cursor: pointer;

            :deep(.el-carousel__container) {
               width: 100%;
               height: 100%;
               border-radius: 10px;

               img {
                  width: 100%;
                  height: 100%;
               }
            }

            :deep(.el-carousel__button) {
               width: 0.31rem !important;
            }
         }
      }
   }

   .information-box {
      .mount-top {
         display: flex;
         margin-top: 1.9vh;

         .mount-left {
            width: 10.4vw;
            margin-left: 1.7vw;

            .switch-box {
               width: 10.4vw;
               height: 8.4vh;
               background: linear-gradient(360deg, rgba(21, 31, 50, 0.464) 0%, rgba(24, 35, 58, 0.8) 98%);
               border: 1px solid;
               border-image: linear-gradient(180deg, rgba(21.000000648200512, 154.00000602006912, 255, 1), rgba(21.000000648200512, 154.00000602006912, 255, 0)) 1 1;

               .shibie {
                  margin-left: 1.6vw;
               }

               .yehang {
                  margin-left: 2.3vw;
               }

               :deep(.el-form-item) {
                  margin-bottom: 0;
                  margin-top: 4px;
               }

               :deep(.el-form-item__label) {
                  color: #FFFFFF;
                  text-shadow: 0px 4px 5px rgba(0, 0, 0, 0.3);
                  font-family: AlibabaPuHuiTi;
               }

               .el-switch {
                  :deep(.el-switch__label) {
                     color: #E8EBEF;
                  }

                  :deep(.el-switch__core) {
                     background: linear-gradient(115deg, rgba(73, 73, 73, 0.83) 0%, #DCDCDC 100%);
                     border: none;
                  }
               }

               .el-switch.is-checked {
                  :deep(.el-switch__core) {
                     background: linear-gradient(115deg, rgba(64, 255, 249, 0.83) 0%, #408CFF 100%);
                     border: none;
                  }
               }
            }

            .photo-box {
               width: 10.4vw;
               height: 8.4vh;
               background: linear-gradient(360deg, rgba(21, 31, 50, 0.464) 0%, rgba(24, 35, 58, 0.8) 98%);
               border: 1px solid;
               border-image: linear-gradient(180deg, rgba(21.000000648200512, 154.00000602006912, 255, 1), rgba(21.000000648200512, 154.00000602006912, 255, 0)) 1 1;
               margin-top: 1.6vh;
               display: flex;
               justify-content: space-around;

               div {
                  margin-top: 1.9vh;
                  cursor: pointer;

                  img {
                     width: 2.8vw;
                     height: 3.3vh;
                  }

                  p {
                     font-family: AlibabaPuHuiTi;
                     font-weight: 400;
                     font-size: .875rem;
                     color: #FFFFFF;
                     text-align: center;
                     margin-top: .5vh;
                  }
               }
            }
         }

         .mount-right {
            width: 5.6vw;
            height: 18.4vh;
            background: linear-gradient(360deg, rgba(21, 31, 50, 0.464) 0%, rgba(24, 35, 58, 0.8) 98%);
            border: 1px solid;
            border-image: linear-gradient(180deg, rgba(21.000000648200512, 154.00000602006912, 255, 1), rgba(21.000000648200512, 154.00000602006912, 255, 0)) 1 1;
            margin-left: .9vw;
            display: flex;

            .shotCut-box {
               width: 3.4vw;
               height: 16.9vh;
               background: rgba(0, 38, 161, 0.5);
               border-radius: 0px 0px 0px 0px;
               margin: .9vh 0 0 .5vw;

               p {
                  width: 3.4vw;
                  height: 5.6vh;
                  text-align: center;
                  line-height: 5.6vh;
                  font-family: AlibabaPuHuiTi;
                  font-weight: 500;
                  font-size: .875rem;
                  color: #FFFFFF;
                  cursor: pointer;
               }

               .posActive {
                  background: rgba(25, 224, 255, 0.41);
                  border-radius: 0px 0px 0px 0px;
                  border: 1px solid #19E0FF;
               }
            }

            .sliderBox {
               width: 10px;
               height: 16.9vh;
               margin-top: .9vh;
            }
         }
      }

      .mount-bottom {
         margin-top: 1.3vh;
         display: flex;

         .shout-box {
            width: 10.4vw;
            height: 16.4vh;
            background: linear-gradient(360deg, rgba(21, 31, 50, 0.464) 0%, rgba(24, 35, 58, 0.8) 98%);
            border: 1px solid;
            border-image: linear-gradient(180deg, rgba(21.000000648200512, 154.00000602006912, 255, 1), rgba(21.000000648200512, 154.00000602006912, 255, 0)) 1 1;
            margin-left: 1.7vw;

            .shout-flex {
               display: flex;
               justify-content: space-around;
               margin-top: 1.5vh;

               .shout-word {
                  position: relative;
                  cursor: pointer;

                  p:nth-child(1) {
                     width: 53px;
                     height: 35px;

                     img {
                        width: 100%;
                        height: 100%;
                     }
                  }

                  p {
                     font-family: AlibabaPuHuiTi;
                     font-weight: 400;
                     font-size: .875rem;
                     color: #FFFFFF;
                     text-align: center;
                  }
               }
            }
         }

         .control-box {
            width: 5.6vw;
            height: 16.4vh;
            background: linear-gradient(360deg, rgba(21, 31, 50, 0.464) 0%, rgba(24, 35, 58, 0.8) 98%);
            border: 1px solid;
            border-image: linear-gradient(180deg, rgba(21.000000648200512, 154.00000602006912, 255, 1), rgba(21.000000648200512, 154.00000602006912, 255, 0)) 1 1;
            margin-left: .9vw;

            .panTilt-box {
               margin: 12px auto;
               cursor: pointer;

               p:nth-child(1) {
                  width: 2.8vw;
                  height: 3.2vh;
                  margin: 0 auto;

                  img {
                     width: 100%;
                     height: 100%;
                  }
               }

               p {
                  font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                  font-weight: 400;
                  font-size: .875rem;
                  color: #FFFFFF;
                  line-height: 1.4vh;
                  text-align: center;
                  margin-top: 6px;
               }
            }
         }
      }
   }

   .shousuo {
      position: absolute;
      left: -40px;
      top: 25%;
      width: 36px;
      height: 190px;
      cursor: pointer;

      img {
         width: 100%;
         height: 100%;
      }
   }
}

.shrink {
   position: absolute;
   top: 32%;
   right: 0;
   width: 36px;
   height: 190px;
   cursor: pointer;
   z-index: 1;

   img {
      width: 100%;
      height: 100%;
   }
}
</style>

<style lang="scss">
.shoutDialog {
   position: absolute;
   top: 42%;
   left: 50%;
   width: 411px;
   height: 272px;
   transform: translate(-50%, -50%);
   background: url("@/assets/icons/hanhua-pop.png") center no-repeat;
   background-size: 100% 100%;

   .closeBtn {
      position: absolute;
      width: 24px;
      height: 24px;
      right: 0;
      top: 2px;
      cursor: pointer;

      img {
         width: 100%;
         height: 100%;
      }
   }

   .selectBox {
      width: 358px;
      height: 143px;
      margin-left: 22px;
      margin-top: 20px;
      overflow-y: auto;

      .selectlist {
         // margin-left: 30px;
         // padding-top: 17px;
         width: 358px;
         height: 32px;
         margin-bottom: 5px;
         background: rgba(0, 8, 14, 0.46);
         display: flex;
         align-items: center;
         cursor: pointer;

         p:nth-child(1) {
            width: 12px;
            height: 12px;

            img {
               width: 100%;
               height: 100%;
            }
         }

         p {
            font-size: 12px;
            color: #CECECE;
            // line-height: 22.23px;
            margin-left: 17px;
         }

         p:nth-child(2) {
            width: 300px;
            white-space: nowrap;
            /* 确保文本在一行内显示 */
            overflow: hidden;
            /* 隐藏溢出的内容 */
            text-overflow: ellipsis;
         }
      }
   }

   .saveBtn {
      position: relative;

      .cancel {
         width: 77px;
         height: 28px;
         background: rgba(64, 158, 255, 0.3);
         box-sizing: border-box;
         border: 1px solid #409EFF;
         color: #fff;
         border-radius: 3px;
         font-weight: 400;
         font-size: 14px;
         text-align: center;
         line-height: 26px;
         cursor: pointer;
         position: absolute;
         right: 125px;
         top: 30px;
      }

      .save {
         width: 77px;
         height: 28px;
         border-radius: 3px;
         background: #409EFF;
         font-weight: 400;
         font-size: 14px;
         color: #FFFFFF;
         text-align: center;
         line-height: 26px;
         cursor: pointer;
         position: absolute;
         right: 30px;
         top: 30px;
      }
   }
}

.flyDialogBox {
   width: 20vw;
   height: 35vh;
   border-radius: 5px;
   background: url("@/assets/images/small-pop.png") no-repeat center;
   background-size: cover;
   padding: 1rem;
   color: #fff;
   padding: .625rem 1rem;

   .el-dialog__title {
      color: #fff;
   }

   .flyform {
      margin-top: 20px;

      .el-input {
         background-color: rgba(0, 0, 0, 0.3);
      }

      .el-form-item__label {
         color: #fff !important;
      }

      .el-input__wrapper {
         background-color: rgba(0, 0, 0, 0.3);

         .el-input__inner {
            color: #fff !important;
         }
      }
   }

   .el-select__wrapper {
      min-height: 3.1vh;
      background-color: rgba(0, 0, 0, 0.3);
      border-radius: 5px;
      color: #fff;
   }

   .el-select__placeholder {
      color: #fff;
   }
}
</style>